import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject, of } from 'rxjs';
import * as Global from '../Model/CommanHttp';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuctionEntryServiceService {
  constructor(private http: HttpClient, private router: Router) { }
  SaveAuctionEntry(PLAuctionEntry: any): Observable<any> {
    return this.http.post(`${Global.base_url}/AuctionEntry/SaveAuctionEntry`, PLAuctionEntry, Global.httpContenttype).pipe(
      map(response => response), catchError(this.handleError<any>('SaveAuctionEntry')));
    //return this.http.post(`${Global.base_url}/AuctionEntry/SaveAuctionEntry`, PLAuctionEntry)

  }
  GetAllDDL(OrgCode): Observable<any> {
    return this.http.get(`${Global.base_url}/AuctionEntry/FillDDL?ind=2` + '&OrgCode=' + OrgCode).pipe(
      map(response => response), catchError(this.handleError<any>('FillDDL')));
  }
  // ************************For Updation **********************
  OnAuctionSearch(Ind: number, OrgCode: number, CityCode: number, AuctionNo: any, AuctionType: number, AuctId: number): Observable<any> {

    return this.http.get(`${Global.base_url}/AuctionEntry/AuctionSearch?Ind=` + Ind + '&OrgCode=' + OrgCode + '&CityCode=' + CityCode + '&AuctionNo=' + AuctionNo + '&AuctionType=' + AuctionType + '&AuctionId=' + AuctId).pipe(
      map(response => response), catchError(this.handleError<any>('AuctionSearch')));
  }

  AuctionUpdation(PLAuctionEntry: any): Observable<any> {
    return this.http.post(`${Global.base_url}/AuctionEntry/AuctionUpdation`, PLAuctionEntry, Global.httpContenttype).pipe(
      map(response => response), catchError(this.handleError<any>('AuctionUpdation')));
}
  GetFillOfficer(Zonecd: Number): Observable<any> {
    return this.http.get(`${Global.base_url}/AuctionEntry/GetFillOfficer?ind=6&ZoneCd=` + Zonecd).pipe(
      map(response => response), catchError(this.handleError<any>('GetFillOfficer')));
  }
  GetDocumentListCategoryWise(Ind: Number, AuctionType: Number, OrgCode: Number, CityCode: Number): Observable<any> {
    return this.http.get(`${Global.base_url}/AuctionEntry/GetDocumentListCategoryWise?ind=` + Ind + `&AuctCtgId=` + AuctionType + `&OrgCode=` + OrgCode + `&CityCode=` + CityCode).pipe(
      map(response => response), catchError(this.handleError<any>('GetDocumentListCategoryWise')));
  }
  GetAuctionGrid(Ind: any, OrgCode: any, CityCode: any): Observable<any> {
    return this.http.get(`${Global.base_url}/AuctionEntry/GetAuctionGrid?Ind=` + Ind + '&OrgCode=' + OrgCode + '&CityCode=' + CityCode, Global.httpContenttype).pipe(
      map(response => response), catchError(this.handleError<any>('GetAuctionGrid')));
  }
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      return of(result as T);
    };
  }
}
